import React from 'react'
import { useTranslation } from 'react-i18next'
import Box, { Box as Divider, Box as IntroBox } from '@node-space/storybook-components/dist/Box'
import CheckBox from '@node-space/storybook-components/dist/CheckBox'
import { Option as RadioOption } from '@node-space/storybook-components/dist/components/Radio/Radio'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import Input from '@node-space/storybook-components/dist/Input'
import { Radio } from '@node-space/storybook-components/dist/Radio'
import Text from '@node-space/storybook-components/dist/Text'
import { Container } from 'components/Container'
import { Description } from 'components/Text'
import { Currencies } from 'constants/General'
import { FormSubmitButton } from 'pages/Verification/_components/FormSubmitButton'

export const HighNetWorthRadioValues = {
  YES: 'yes',
  NO: 'no',
} as const
type HighNetWorthRadioValue = (typeof HighNetWorthRadioValues)[keyof typeof HighNetWorthRadioValues]

type HighNetWorthRadioOption = RadioOption & {
  value: HighNetWorthRadioValue
}

export const HighNetWorthInvestorForm = () => {
  const { t } = useTranslation()

  const incomeCurrencyPostLabel = (
    <Box divider="left" paddingL={12}>
      <Text size="sm" color="text-500">
        {Currencies.GBP}
      </Text>
    </Box>
  )

  const optionsA: HighNetWorthRadioOption[] = [
    {
      value: HighNetWorthRadioValues.YES,
      secondaryLabel: t('yes'),
    },
    {
      value: HighNetWorthRadioValues.NO,
      secondaryLabel: t('no'),
    },
  ]

  const optionsB: HighNetWorthRadioOption[] = [
    {
      value: HighNetWorthRadioValues.YES,
      secondaryLabel: t('yes'),
    },
    {
      value: HighNetWorthRadioValues.NO,
      secondaryLabel: t('no'),
    },
  ]

  const optionsC: HighNetWorthRadioOption[] = [
    {
      value: HighNetWorthRadioValues.YES,
      secondaryLabel: t('yes'),
    },
  ]

  const formFields = {
    questionA: {
      label: t('finprom.selfCategorisation.highNetWorthForm.questionALabel'),
      secondaryLabel: t('finprom.selfCategorisation.highNetWorthForm.questionADescription'),
      value: '',
      options: optionsA,
      onChange: value => {},
    },
    questionAIncome: {
      label: t('finprom.selfCategorisation.highNetWorthForm.questionAIncomeLabel'),
      value: '',
      placeholder: t('finprom.selfCategorisation.highNetWorthForm.questionAIncomePlaceholder'),
    },
    questionB: {
      label: t('finprom.selfCategorisation.highNetWorthForm.questionBLabel'),
      secondaryLabel: t('finprom.selfCategorisation.highNetWorthForm.questionBDescription'),
      value: '',
      options: optionsB,
      onChange: value => {},
    },
    questionC: {
      label: t('finprom.selfCategorisation.highNetWorthForm.questionCLabel'),
      value: '',
      options: optionsC,
      onChange: value => {},
    },
    acceptRisk: {
      label: t('finprom.selfCategorisation.highNetWorthForm.acceptCheckboxLabel'),
      value: false,
    },
  }

  const onSubmit = () => {
    // TODO: handle submit step - ONB-1506
  }

  return (
    <form onSubmit={onSubmit}>
      <Container>
        <IntroBox>
          <InputLabel>{t('finprom.selfCategorisation.highNetWorthForm.statementTitle')}</InputLabel>
          <Description>
            {t('finprom.selfCategorisation.highNetWorthForm.statementParagraph')}
          </Description>
        </IntroBox>
        <Radio {...formFields.questionA} hasParagraphLayout />
        <Description>
          {t('finprom.selfCategorisation.highNetWorthForm.questionAIncomeIntro')}
        </Description>
        <Input {...formFields.questionAIncome} postLabel={incomeCurrencyPostLabel} />
        <Divider divider="bottom" />
        <Radio {...formFields.questionB} hasParagraphLayout />
        <Divider divider="bottom" />
        <Radio {...formFields.questionC} hasParagraphLayout />
        <Divider divider="bottom" />
        <CheckBox {...formFields.acceptRisk} labelColour="light" />
        <FormSubmitButton disabled loading={false} />
      </Container>
    </form>
  )
}
